import sdk from '@/sdk';
import assert from 'assert';
import * as store from '@/store';
import {curPageType} from '@/buried';

// 获取知识库成员数和人数
export const getRepositoryMember = async (
    repository: Repository,
    pageSize = 1,
    pageNum = 1
) => {
    try {
        assert(repository);
        const {spaceGuid, groupGuid, repositoryGuid} = repository;
        const result = await sdk.as.getMembers(spaceGuid, groupGuid, repositoryGuid, pageSize, pageNum);

        return result;
    } catch (error) {
        return {};
    }
};

// 获取文档成员数和人数
export const getDocMember = async (
    repository: Repository,
    docGuid?: string,
    pageSize = 1,
    pageNum = 1
) => {
    try {
        assert(repository);
        assert(docGuid);
        const ksServer = await sdk.getKsServer(repository);
        const pageInfo = {
            repositoryGuid: repository.repositoryGuid,
            pageNum,
            pageSize,
        };
        const result = await ksServer.getHavePowerPersonPaging(docGuid, pageInfo);
        return result;
    } catch (error) {
        return {};
    }
};

// 获取协作目录成员和人数
export const getDirectoryMember = async (
    repository: Repository,
    docGuid?: string,
    pageSize = 1,
    pageNum = 1
) => {
    try {
        assert(repository);
        assert(docGuid);
        const ksServer = await sdk.getKsServer(repository);
        const result = await ksServer.getTeamMembers(repository.repositoryGuid, pageSize, pageNum, docGuid);
        return result;
    } catch (error) {
        return {};
    }
};

export const getBookStatus = async (
    repository: Repository,
    rootGuid: string
) => {
    try {
        const ksServer = await sdk.getKsServer(repository);
        const result = await ksServer.getBookPublicStatus(rootGuid);
        return result;
    } catch (error) {
        return {};
    }
};

export function getPageType(curDocument?: WizDocument): string {
    const curDoc = curDocument || store.getCurDocument();
    if (curDoc?.type === 2) {
        return curPageType.directory;
    }
    if (curDoc?.type === 4) {
        return curPageType.sheet;
    }
    if (curDoc?.type === 6) {
        return curPageType.ppt;
    }
    return curPageType.doc;
}
